/** @format */

import lodash from 'lodash';
// import getDataByModel from '@root/utils/get-attributes-by-str'

function getDataByModel($scope, modelStr, otherWiseVal) {
  otherWiseVal = otherWiseVal || null;

  if (!$scope) {
    return otherWiseVal;
  }

  var arr = modelStr.split('.'),
    len = arr.length,
    result = $scope;
  // console.log('len:',len)
  if (len === 1) {
    // if($scope.hasOwnProperty(arr[0])) {
    //     return $scope[arr[0]]
    // }
    // else if($scope.result && $scope.result[arr[0]]) {
    //     return $scope.result[arr[0]]
    // }
    return $scope.hasOwnProperty(arr[0]) ? $scope[arr[0]] : otherWiseVal;
  } else if (len > 1) {
    var isError = false;
    for (var i in arr) {
      if (typeof result[arr[i]] === 'undefined') {
        isError = true;
        break;
      } else {
        result = result[arr[i]];
      }
    }
    if (isError) {
      return otherWiseVal;
    } else {
      return result;
    }
  } else if (len === 0) {
    return otherWiseVal;
  }
}
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function isSpecificValue(val) {
  return val instanceof Buffer || val instanceof Date || val instanceof RegExp ? true : false;
}

function cloneSpecificValue(val) {
  if (val instanceof Buffer) {
    var x = new Buffer(val.length);
    val.copy(x);
    return x;
  } else if (val instanceof Date) {
    return new Date(val.getTime());
  } else if (val instanceof RegExp) {
    return new RegExp(val);
  } else {
    throw new Error('Unexpected situation');
  }
}

/**
 * Recursive cloning array.
 */
function deepCloneArray(arr) {
  var clone = [];
  arr.forEach(function(item, index) {
    if (typeof item === 'object' && item !== null) {
      if (Array.isArray(item)) {
        clone[index] = deepCloneArray(item);
      } else if (isSpecificValue(item)) {
        clone[index] = cloneSpecificValue(item);
      } else {
        clone[index] = deepExtend({}, item);
      }
    } else {
      clone[index] = item;
    }
  });
  return clone;
}

function poll(fn, callback, errback, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 20000);
  interval = interval || 100;
  (function p() {
    // 如果条件满足，则执行！
    if (fn()) {
      callback();
    }

    // 如果条件不满足，但并未超时，再来一次
    else if (Number(new Date()) < endTime) {
      setTimeout(p, interval);
    }

    // 不匹配且时间消耗过长，则拒绝！
    else {
      errback(new Error('timed out for ' + fn + ': ' + arguments));
    }
  })();
}

const closestVM = (vm, ...keys) => (
  console.log(),
  // console.log('keys--:', keys, vm),
  // keys.find(key => (key in (vm||{}) ? vm : key in (vm.$parent||{}) ? vm.$parent : closestVM(vm.$parent, ...keys)))
  keys.find(key => key.split('.')[0] in vm.$parent) ? vm.$parent : closestVM(vm.$parent, ...keys)
);

const closestVMProp = (vm, ...keys) =>
  keys.map(key => getDataByModel(closestVM(vm, ...keys), key)).find(item => item != undefined);

const getDataByMultiModel = function(data, ...modelStrs) {
  let result = null;
  modelStrs.forEach(modelStr => {
    let findResult = getDataByModel(data, modelStr);
    if (!result && findResult) {
      result = findResult;
    }
  });
  return result;
};
const list2ObjByProp = (arr, prop) => {
  let obj = {};

  arr.forEach(item => {
    obj[item[prop]] = item;
  });

  return obj;
};

//根据vnode tag name正则从父元素的所有子孙元素里匹配到对应vm instance
function matchingDescendants(vm, matcher, options = { first: true }, childKey = '$children') {
  let descendants = vm[childKey];
  let newDescendants = [].concat(descendants);
  let descendant;
  let returnFirst = (options || {}).first;
  let matches = [];

  for (let x = 0; x < newDescendants.length; x++) {
    descendant = newDescendants[x];

    if (
      (matcher instanceof RegExp && matcher.test((descendant._vnode.tag || '').toLowerCase())) ||
      (typeof matcher === 'function' && matcher(descendant))
    ) {
      if (returnFirst) {
        return descendant;
      } else {
        matches.push(descendant);
        console.log('matches len--:', matches.length);
        console.log('descendant len--:', descendant.length);
        console.log('newDescendants len--:', newDescendants.length);
      }
    }

    for (let y = 0, len = (descendant[childKey] || []).length; y < len; y++) {
      newDescendants.push(descendant[childKey][y]);
    }
  }

  return matches.length === 0 ? false : matches;
}

var deepExtend = function(/*obj_1, [obj_2], [obj_N]*/) {
  if (arguments.length < 1 || typeof arguments[0] !== 'object') {
    return false;
  }

  if (arguments.length < 2) {
    return arguments[0];
  }

  var target = arguments[0];

  // convert arguments to array and cut off target object
  var args = Array.prototype.slice.call(arguments, 1);

  var val, src, clone;

  args.forEach(function(obj) {
    // skip argument if isn't an object, is null, or is an array
    if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
      return;
    }

    Object.keys(obj).forEach(function(key) {
      src = target[key]; // source value
      val = obj[key]; // new value

      // recursion prevention
      if (val === target) {
        return;

        /**
         * if new value isn't object then just overwrite by new value
         * instead of extending.
         */
      } else if (typeof val !== 'object' || val === null) {
        target[key] = val;
        return;

        // just clone arrays (and recursive clone objects inside)
      } else if (Array.isArray(val)) {
        target[key] = deepCloneArray(val);
        return;

        // custom cloning and overwrite for specific objects
      } else if (isSpecificValue(val)) {
        target[key] = cloneSpecificValue(val);
        return;

        // overwrite by new value if source isn't object or array
      } else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
        target[key] = deepExtend({}, val);
        return;

        // source value and new value is objects both, extending...
      } else {
        target[key] = deepExtend(src, val);
        return;
      }
    });
  });

  return target;
};

const firstUpperCase = function() {
  return this.replace(/\b(\w)(\w*)/g, function($0, $1, $2) {
    return $1.toUpperCase() + $2.toLowerCase();
  });
};

let o = {
  matchingDescendants,
  log() {
    if (window.BX_MODE == 1 && !window.NO_LOG_MODE) {
      console.log.apply(window, arguments);
    }
  },
  closestVM,
  getDataByModel,
  getDataByMultiModel,
  closestVMProp,
  firstUpperCase,
  getDataByLoopedData($scope, modelStr, loopSpliter = '[LOOP]') {
    if (!/^\[(.*?)\]$/.test(loopSpliter)) {
      throw `setLoopDataByArrayModel:loop spliter can only starts with [,and ends with ],and pure string between`;
    }
    return o.getDataByModel(
      $scope,
      modelStr.replace(new RegExp('\\' + loopSpliter.split(']')[0] + '\\' + ']', 'g'), '0'),
      loopSpliter
    );
  },
  setLoopDataByArrayModel($scope, modelStr, val, loopSpliter = '[LOOP]') {
    if (!/^\[(.*?)\]$/.test(loopSpliter)) {
      throw `setLoopDataByArrayModel:loop spliter can only starts with [,and ends with ],and pure string between`;
    }
    if (modelStr.endsWith(loopSpliter)) {
      throw `setLoopDataByArrayModel:${modelStr} can not ends with ${loopSpliter}`;
    } else if (modelStr.endsWith('.')) {
      throw `setLoopDataByArrayModel:${modelStr} can not ends with .`;
    }
    let previousLoopSpliter = loopSpliter;
    loopSpliter = '.' + loopSpliter + '.';
    let arr = modelStr.split(loopSpliter);

    if (arr.length < 2) {
      return o.setDataByModel.apply(null, Array.from(arguments).slice(0, 3));
    } else if (arr.length > 2) {
      throw `setLoopDataByArrayModel:loopSpliter---${previousLoopSpliter}--- can shows only one time`;
    } else {
      $scope = o.getDataByModel($scope, arr[0]);
      if (Array.isArray($scope)) {
        $scope.forEach((item, index) => {
          o.setDataByModel($scope, index + '.' + arr[1], val);
        });
      } else {
        throw `setLoopDataByArrayModel:${arr[0]} is not an array`;
      }
    }
  },
  setDataByModel: function($scope, modelStr, val) {
    console.log('set data by model args--:', arguments);
    var arr = modelStr.split('.'),
      len = arr.length;
    if (len === 1) {
      $scope[arr[0]] = val;
    } else if (len > 1) {
      var ns = arr,
        obj = $scope;
      for (var i = 0; i < len - 1; i++) {
        var key = ns[i];
        obj = obj[key];
      }
      console.log('this is obj and key:', obj, ns[len - 1], val);

      obj[ns[len - 1]] = val;
    }
  },
  poll,
  list2ObjByProp,
  formatDate(date) {
    return o.formatTime(date, true);
  },
  simpleTplEngine(options) {
    options = o.deepExtend(
      {
        left_split: '{{',
        right_split: '}}',
        tpl: '',
        data: null
      },
      options
    );
    if (options.data == null) {
      return options.tpl;
    } else {
      var reg = new RegExp(options.left_split + '(.+?)' + options.right_split, 'gi');
      var strs = options.tpl.match(reg) || [],
        tpl = options.tpl;
      for (var i = 0; i < strs.length; i++) {
        var str = strs[i];
        strs[i] = str.substring(options.left_split.length, str.length - options.right_split.length);
        // tpl = tpl.replace(str, str.indexOf(".") == -1 ? ([strs[i]] in options.data?(options.data[strs[i]]):'') : (util.getDataByModel(options.data, strs[i])) || '')  //xgp-20180123注释
        //xgp-20180123添加
        if (str.indexOf('.') == -1) {
          tpl = tpl.replace(str, [strs[i]] in options.data ? options.data[strs[i]] : '');
        } else {
          let tempObj = o.getDataByModel(options.data, strs[i]);
          //暂不支持对象和字符串同时调用，如{{l('{approveLocale.approve.items}和{demo.test}至少选择一项')}}
          if (typeof tempObj === 'object') {
            //如果是返回的是对象
            tpl = tempObj;
          } else {
            //字符串
            tpl = tpl.replace(str, tempObj);
          }
        }
        // console.info("++++++++++")
        // console.info(util.getDataByModel(options.data, strs[i]));
        // console.info(str)
        // tpl = tpl.replace(str, str.indexOf(".") == -1 ? (options.data[strs[i]] || '') : (util.getDataByModel(options.data, strs[i])) || '')
      }
      // console.log("return tpl:"+tpl)
      return tpl;
    }
  },
  moment2YM(m) {
    let year = m.year(),
      month = m.month() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    return year + '-' + month;
  },
  formatTime(date, hmdOnly = false) {
    date = date || new Date();
    let t = date.getTime();
    if (typeof t === 'number' && window.isNaN(t)) {
      return '';
    }

    let d = new Date(date);

    var yyyy = d.getFullYear().toString();
    var mm = (d.getMonth() + 1).toString(); // getMonth() is zero-based
    var dd = d.getDate().toString();
    var hh = d.getHours().toString();
    var ii = d.getMinutes().toString();
    var ss = d.getSeconds().toString();
    // return '20180211'+hh+ii+ss;

    let res = yyyy + '-' + (mm[1] ? mm : '0' + mm[0]) + '-' + (dd[1] ? dd : '0' + dd[0]);
    if (!hmdOnly) {
      res += ' ' + (hh[1] ? hh : '0' + hh[0]) + ':' + (ii[1] ? ii : '0' + ii[0]) + ':' + (ss[1] ? ss : '0' + ss[0]);
    }

    return res;
    // return yyyy+'/' + (mm[1]?mm:"0"+mm[0])+'/' + (dd[1]?dd:"0"+dd[0])+' '+ (hh[1]?hh:"0"+hh[0])+':'+ (ii[1]?ii:"0"+ii[0])+':'+ (ss[1]?ss:"0"+ss[0])

    // return yyyy+'-' + (mm[1]?mm:"0"+mm[0])+'-' + (dd[1]?dd:"0"+dd[0]);
  },
  deepExtend,
  guid,
  generateNewListByListItemExtendDefine(list, byKey = 'comp', extendKey = 'extend') {
    let arr = [];
    list.forEach(item => {
      // o.log('item in generate new list--:', item)

      if (extendKey in item) {
        arr.push(o.deepExtend({}, list.find(row => row[byKey] == item[extendKey]), item));
        // console.log(
        //   'find in list--:',
        //   byKey,
        //   extendKey,
        //   list.find(row => row[byKey] == item[extendKey]),
        // )
      } else {
        arr.push(item);
      }

      // arr.push(
      //   extendKey in item
      //     ? o.deepExtend(
      //         list.find(row => row[byKey] == item[extendKey]),
      //         item,
      //       )
      //     : item,
      // )
      // debugger
    });
    return arr;
  },
  generateSingleCompPropByDefaultValue(v) {
    return {
      default: v,
      type:
        window[
          firstUpperCase.call(
            'array object string boolean'.split(' ').find(type => lodash['is' + o.firstUpperCase.call(type)](v))
          )
        ]
    };
  },
  generateCompPropsByCompDefine(compDefine) {
    let res = {};
    res[compDefine.valueKey] = o.generateSingleCompPropByDefaultValue(compDefine.valueKey);
    for (var i in compDefine.attrs) {
      res[i] = o.generateSingleCompPropByDefaultValue(compDefine.attrs[i]);
    }
    return res;
  }
};

export default o;
